export const getInitials = (name: string) => {
  const nameArray = name.split(" ");
  const initials = nameArray
    .slice(0, 3)
    .map((word) => word.charAt(0))
    .join("")
    .toUpperCase();
  return initials;
};

export const formatCPF = (value: string): string => {
  value = value.replace(/\D/g, "");
  if (value.length < 4) {
    return value;
  } else if (value.length < 7) {
    return `${value.slice(0, 3)}.${value.slice(3)}`;
  } else if (value.length < 10) {
    return `${value.slice(0, 3)}.${value.slice(3, 6)}.${value.slice(6)}`;
  } else {
    return `${value.slice(0, 3)}.${value.slice(3, 6)}.${value.slice(
      6,
      9
    )}-${value.slice(9)}`;
  }
};
export const formatPhone = (value: string) => {
  const numericValue = value.replace(/\D/g, "");

  if (numericValue.length < 3) {
    return numericValue.replace(/(\d{1,2})/, "($1");
  } else if (numericValue.length < 7) {
    return numericValue.replace(/(\d{2})(\d{1,4})/, "($1) $2");
  } else if (numericValue.length < 11) {
    return numericValue.replace(/(\d{2})(\d{4})(\d{1,4})/, "($1) $2-$3");
  } else {
    return numericValue.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
  }
};